import withRole from "../../Hooks/withRole";
import genericStyles from "../../Styles/genericStyles.module.css";
import MUIDataTableCustomStyle from "../MUIDataTableCustomStyle";
import { ETableEditAction } from "../../Utils/Enums";
import { endpoints } from "../../Utils/UrlEnum";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useEffect, useState } from "react";
import ModuleForm from "./ModuleForm";
import GenericModal from "../GenericModal";
import { AxiosResponse } from "axios";
import { getData } from "../../Services/getData";
import { Button } from "@mui/material";
import { FormsIds } from "../../Utils/Constants";

function ModulesTable() {
  const [openModal, setOpenModal] = useState(false);
  const [contextValue, setContextValue] = useState();
  const [courses, setCourses] = useState([]);
  const [triggerReload, setTriggerReload] = useState(false);

  useEffect(() => {
    getCourses();
  }, []);

  const getCourses = async () => {
    getData(endpoints.courses).then((res: AxiosResponse) => {
      if (!res?.data) return;
      setCourses(res.data);
    });
  };
  const columns = [
    {
      name: "name",
      label: Vocabulary.name,
    },
    {
      name: "courseId",
      label: Vocabulary.course,
      options: {
        customBodyRender: (course: any) => {
          return course?.name;
        },
      },
    },
    {
      name: "mainImageId",
      label: Vocabulary.mainImage,
      options: {
        customBodyRender: (value: any) => {
          return <img width={50} src={value}></img>;
        },
      },
    },
  ];
  return (
    <div className={genericStyles.mainContainer}>
      <MUIDataTableCustomStyle
        buttons={[]}
        onEditAction={ETableEditAction.MODAL}
        title={Vocabulary.modules}
        columns={columns}
        CRUDEndPoint={endpoints.modules}
        handleModalForm={setOpenModal}
        setContextValue={setContextValue}
        triggerReload={triggerReload}
        addOrEditForm={
          <GenericModal
            title={Vocabulary.addModule}
            open={openModal}
            onClose={() => {
              setOpenModal(false);
              setContextValue(undefined);
            }}
            actions={
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => {
                    setOpenModal(false);
                    setContextValue(undefined);
                  }}
                >
                  {Vocabulary.cancel}
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  size="large"
                  color="primary"
                  form={FormsIds.moduleForm}
                >
                  {Vocabulary.save}
                </Button>
              </div>
            }
          >
            <ModuleForm
              courses={courses}
              open={openModal}
              contextValue={contextValue}
              onClose={() => {
                setTriggerReload(!triggerReload);
                setOpenModal(false);
                setContextValue(undefined);
              }}
            />
          </GenericModal>
        }
      />
    </div>
  );
}

export default withRole(ModulesTable);
